module.exports = __webpack_public_path__ + "img/clearmap.5f0ada41.svg";